import { BlockRenderer } from '@/components/BlockRenderer';
import { RelatedPosts } from '@/components/molecules';
import { ComparatorHighlight, PlanCategory, BestOffers } from '@/components/organisms';
import { WhyChooseLemon } from './WhyChooseLemon';
import phoneImage from '@/assets/img/woman-hand-holding-smart-phone.webp';
import routerImage from '@/assets/img/wifi-router.webp';
import type { AppData } from '@/types/app';
import './Home.scss';

interface HomeProps {
  data: AppData;
}

export function Home({ data }: HomeProps) {
  const { blocks, related_posts, pagination, home } = data;

  return (
    <div className="home">
      <ComparatorHighlight />
      <section className="home__categories">
        <h2 className="home__categories-title">
          Nos comparateurs d&apos;offres Telecom &amp; Internet
        </h2>
        <div className="home__categories-grid">
          <PlanCategory
            className="plan-category--mobile"
            image={phoneImage}
            tags={home?.mobileTags ?? []}
          />
          <PlanCategory
            title="Box Internet"
            cta="Comparer toutes les<br> Box Internet"
            href="/comparateur/"
            className="plan-category--internet"
            image={routerImage}
            tags={home?.internetTags ?? []}
          />
        </div>
      </section>
      <BestOffers />
      <WhyChooseLemon />
      <RelatedPosts
        posts={(related_posts ?? []).slice(0, 21)}
        currentPage={pagination?.current_page}
        totalPages={pagination?.total_pages}
        basePath="/actualites/"
      />
      <BlockRenderer blocks={blocks} />
    </div>
  );
}
